export default __webpack_public_path__ + "static/media/Ex.b20973e9.gif";